module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("2iHFc"))).then(() => parcelRequire('dgrzF'));